import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { APPCONFIG } from './config';
import { LayoutService } from './layout/layout.service';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { HttpService } from './shared/services/http.service';
import { ErrorHandler } from './shared/services/error-handler.service';
import { SessionHandler } from './shared/services/session-handler.service';
import {TranslateService} from 'ng2-translate';

// 3rd
import 'styles/font-awesome.scss';
import 'styles/material2-theme.scss';
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';

@Component({
    selector: 'app-root',
    template: require('./app.component.html'),
    providers: [LayoutService,HttpService,ErrorHandler,SessionHandler],
})
export class AppComponent {
    AppConfig: any;
    languageId: any;
    constructor(private router: Router, private layoutService:LayoutService,private sessionHandler:SessionHandler,
                public dialog: MdDialog,  private translate: TranslateService) {

        this.languageId = this.sessionHandler.getItem('languageId');
        if(!this.languageId){
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }

    ngOnInit() {
        this.AppConfig = APPCONFIG;

        // Scroll to top on route change
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            document.body.scrollTop = 0;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts